import { render } from "./CurrentVersionScreen.vue?vue&type=template&id=ca27e1a8&scoped=true"
import script from "./CurrentVersionScreen.vue?vue&type=script&lang=js"
export * from "./CurrentVersionScreen.vue?vue&type=script&lang=js"

import "./installer-page.scss?vue&type=style&index=0&id=ca27e1a8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca27e1a8"]])

export default __exports__